import { DocumentFilterDto } from "../../models/filters/document-filter.dto";

export class PageQuery {
    skip: number;
    take: number;

    /**
     *
     */
    constructor(skip: number, take: number) {
        this.skip = skip;
        this.take = take;
    }
}


export class DocumentQuery {
    filter?: DocumentFilterDto;    
    query?: string;
    typeId: string;
    sort?: string;
    sortDesc?: boolean;
    count?: number;
    size?: number;
    page = 1;

    /**
     *
     */
    constructor(query: string | DocumentFilterDto, typeId: string, sort?: string, sortDesc?: boolean, count?: number, size?: number) {
        if (query instanceof DocumentFilterDto) {
            this.filter = <DocumentFilterDto>query;
        }
        else {
            this.query = <string>query;
        }
        this.typeId = typeId;
        this.sort = sort;
        this.sortDesc = sortDesc;
        this.count = count;
        this.size = size || 25;
    }

    public get skip(): number {
        return (this.page - 1) * this.size;
    }

    public getPage(page: number): PageQuery {
        this.page = page;
        const skip = this.skip;
        const ret = new PageQuery(skip, this.size);
        return ret;
    }
    public nextPage(): PageQuery {
        const next = this.page + 1;
        return this.getPage(next);
    }
    public prevPage(): PageQuery {
        const next = this.page > 1 ? this.page - 1 : 1;
        if (next < this.page) {
            return this.getPage(next);
        }
    }
}

